import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";

type StakingSecurityItemProps = {
  model: StakingSecurityModel;
};

export type StakingSecurityModel = {
  icon: any;
  iconPy?: string;
  title: string;
  descriptionTexts: string[];
};

export const StakingSecurityItem = (props: StakingSecurityItemProps) => {
  const { icon, iconPy, title, descriptionTexts } = props.model;

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box alignSelf="stretch" display="flex" justifyContent="center">
        <Box height="100px" py={iconPy}>
          <img src={icon} height="100%" alt="icon" />
        </Box>
      </Box>

      <Typography
        fontSize="20px"
        color="white"
        variant="bold"
        mt="19px"
        mb="16px"
      >
        {title}
      </Typography>

      {descriptionTexts.map((text) => (
        <Typography
          key={text}
          fontSize="16px"
          color="#848484"
          display="flex"
          alignItems="center"
          flexDirection="column"
        >
          {text}
        </Typography>
      ))}
    </Box>
  );
};
